import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, finalize, map } from 'rxjs';
import type { MaidProfile, MaidProfileResponse } from '../../profile/maid-profile.model';
import { API_ENDPOINTS } from '@core/constants/api.const';
import { environment } from '@environments/environment';
import { buildUrl } from '@shared/utils/url.util';

@Injectable({
    providedIn: 'root'
})
export class MaidService {
    private readonly http = inject(HttpClient);

    readonly maidProfile = signal<MaidProfile | null>(null);
    readonly isLoading = signal(false);

    /**
     * Load maid profile data from /api/me-maid
     * Stores result in maidProfile signal
     */
    loadMaidProfile(): Observable<MaidProfile> {
        this.isLoading.set(true);
        const url = `${environment.API_URL}${API_ENDPOINTS.maid.profile}`;

        return this.http.get<MaidProfileResponse>(url).pipe(
            tap((response) => {
                const profile: MaidProfile = {
                    id: response.data.id,
                    name: response.data.name,
                    photoPath: buildUrl(response.data.photo_path),
                    videoPath: buildUrl(response.data.video_path),
                    dob: response.data.dob,
                    homeAddress: response.data.home_address,
                    agencyName: response.data.agency_name,
                };
                this.maidProfile.set(profile);
            }),
            map(() => this.maidProfile()!),
            finalize(() => this.isLoading.set(false))
        );
    }
}